import { Directive, Input, HostBinding } from '@angular/core';

let nextUniqueId = 0;

// selector: '[ridangoError]'

@Directive( {
    // tslint:disable-next-line:directive-selector
    selector: 'ridango-error',
    // selector: 'ridango-error',
    // tslint:disable:use-host-property-decorator
    host: {
        'class': 'ridango-error',
        'role': 'alert',
        '[attr.id]': 'id',
    }
} )
export class ErrorDirective {
    // @HostBinding( 'class' ) class = 'ridango-error';
    // @HostBinding( 'role' ) role = 'alert';
    // @HostBinding( '[attr.id]' ) id = `ridango-error-${nextUniqueId++}`;



    @Input() id = `ridango-error-${nextUniqueId++}`;
    constructor() { }

}
